/**
 * Resource upload/edit field tooltips (from PAM-DAM tool-tips.csv).
 * Shared Selection components use these on both upload and edit screens.
 */
export const RESOURCE_FIELD_TOOLTIPS = {
  assetName: 'Enter the approved name of the asset as it should appear.',
  directoryLink: "Add a direct link to the asset's source file or primary storage location.",
  learningExperience: 'Select the JA learning experience(s) associated with this asset. Select all that apply.',
  sessionThemeTopicNumber: 'Enter the session, theme, or topic number where this asset is used.',
  slideNumber: 'Enter the slide number(s) where this asset appears, if applicable.',
  characterTrait: 'Select the character trait(s) addressed or represented by this asset. Select all that apply.',
  jaCompetencyCategories: 'Select the JA Competency Category associated with this asset. Select all that apply.',
  jaCompetencies:
    'Select the specific JA Competency or Competencies associated with this asset. Select all that apply.',
  ksas: 'Select the Knowledge, Skills, and Attitudes (KSAs) associated with this asset. Select all that apply.',
  behavioralIndicators: 'Select the 3DE Behavioral Indicator(s) associated with this asset. Select all that apply.',
  learningObjectives: 'Enter the Learning Objective(s) supported by this asset.',
  studentFacing: 'Indicate whether the students directy view, read, hear, use, or interact with this asset.',
  briefDescription: 'Enter a short description of the asset and its purpose or content.',
  keywords:
    'Select the relevant search terms that will help users find this asset. Include terms not already captured in other metadata fields when useful. Select all that apply.',
  associatedResources:
    'Identify other resources or assets that are directly related to or used with this asset. Select all that apply.',
  imageSource:
    'Select the source(s) from which the image was obtained. If the asset combines images from multiple sources, select all that apply.',
  linkToStockImageSource:
    'Add the direct URL to the original source page for the image. If multiple images or sources were used, include a link for each.',
  publishedOutputTool:
    'Select the program used to create the published asset. For example, select InDesign for a PDF created in InDesign.',
  altText:
    'Enter concise alternative text that communicates the meaningful visual information in the image for users who cannot see it.',
  mediaRightsReuseFlag:
    'Indicate whether the media is approved for reuse in other JA materials based on its licensing or usage rights.',
} as const;

/** @deprecated Prefer RESOURCE_FIELD_TOOLTIPS for resource metadata fields. */
export const TOOLTIP_TEXT_TBD = 'To be determined';
